export default function deletePaymentReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'DELETE_PAYMENT_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'DELETE_PAYMENT_ERROR':
            return {...state, ...{ error: action.error }};

        case 'DELETE_PAYMENT_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}